import React, { useState, useEffect } from 'react';
import { Routes, Route, NavLink, useLocation } from 'react-router-dom';
import './App.css';
import Home from './Home';
import VideoPage from './VideoPage';
import MusicPage from './MusicPage';
import MeetMike from './MeetMike';
import Calendar from './Calendar';
import Contact from './Contact';

function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
    document.body.style.overflow = '';
  }, [location]);

  const toggleMenu = () => {
    const next = !menuOpen;
    setMenuOpen(next);
    document.body.style.overflow = next ? 'hidden' : '';
  };

  const links = [
    { to: '/video', label: 'Video' },
    { to: '/music', label: 'Music' },
    { to: '/meetmike', label: 'About' },
    { to: '/calendar', label: 'Shows' },
    { to: '/contact', label: 'Contact' },
  ];

  return (
    <>
      <nav className="main-nav">
        <NavLink className="nav-brand" to="/">
          Mike Mallick
          <span>Smooth &bull; Soul &bull; Rock</span>
        </NavLink>

        <ul className="nav-links">
          {links.map(l => (
            <li key={l.to}>
              <NavLink
                to={l.to}
                className={({ isActive }) => isActive ? 'active' : ''}
              >
                {l.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <button
          className={`nav-toggle${menuOpen ? ' open' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </nav>

      <div className={`mobile-menu${menuOpen ? ' open' : ''}`}>
        {links.map(l => (
          <NavLink key={l.to} to={l.to}>{l.label}</NavLink>
        ))}
      </div>
    </>
  );
}

function App() {
  return (
    <>
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/video" element={<VideoPage />} />
        <Route path="/music" element={<MusicPage />} />
        <Route path="/meetmike" element={<MeetMike />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <footer className="main-footer">
        <p>&copy; {new Date().getFullYear()} <span>Mike Mallick</span> &bull; Smooth &bull; Soul &bull; Rock &bull; Maryland</p>
      </footer>
    </>
  );
}

export default App;
